import { useEffect, useState } from "react";
import usePWAInstall from "../hooks/usePWAInstall";
import useIOSInstall from "../hooks/useIOSInstall";

const DISMISS_KEY = "pwa_install_dismissed";

export default function PWAInstallBanner() {
  const { isInstallable, installApp } = usePWAInstall();
  const { showIOSBanner } = useIOSInstall();

  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [installState, setInstallState] = useState("idle");
  const [icon, setIcon] = useState(null);

  const isMobile = () =>
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  /* Load icon from manifest */
  useEffect(() => {
    fetch("./manifest.json")
      .then((res) => res.json())
      .then((manifest) => {
        const best =
          manifest.icons?.find((i) => i.sizes === "192x192") ||
          manifest.icons?.find((i) => i.sizes === "512x512");
        if (best) setIcon(best.src);
      })
      .catch(() => {});
  }, []);

  /* Show banner */
  /* useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (standalone) return;
    if (!isMobile()) return;
    if (localStorage.getItem(DISMISS_KEY)) return;

    if (isInstallable || showIOSBanner) {
      setVisible(true);
      setTimeout(() => setOpen(true), 100);
    }
  }, [isInstallable, showIOSBanner]); */

	/* Show banner with 2s delay */
	useEffect(() => {
	  const standalone =
		window.matchMedia("(display-mode: standalone)").matches ||
		window.navigator.standalone === true;

	  if (standalone) return;
	  if (!isMobile()) return;
	  if (localStorage.getItem(DISMISS_KEY)) return;

	  const timer = setTimeout(() => {
		if (isInstallable || showIOSBanner) {
		  setVisible(true);
		  requestAnimationFrame(() => setOpen(true));
		}
	  }, 2000); // ⏱ 2 seconds delay

	  return () => clearTimeout(timer);
	}, [isInstallable, showIOSBanner]);

  /* Auto-close on install */
  useEffect(() => {
    const onInstalled = () => {
      localStorage.setItem(DISMISS_KEY, "1");
      setInstallState("installed");

      if (navigator.vibrate) navigator.vibrate([80, 40, 80]);

      setTimeout(() => {
        setOpen(false);
        setTimeout(() => setVisible(false), 300);
      }, 1000);
    };

    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);

  const handleInstall = async () => {
    setInstallState("installing");
    await installApp();
  };

  const close = () => {
    //localStorage.setItem(DISMISS_KEY, "1");
    setOpen(false);
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  return (
    <div className={`pwa-sheet ${open ? "open" : ""}`}>
      <div className="grabber" />

      <div className="sheet-header">
        {icon && <img src={icon} alt="App Icon" />}
        <div>
          <h6>BRS</h6>
          <p>Fast · Secure · Offline ready</p>
        </div>
      </div>

      <div className="sheet-actions">
        {isInstallable && (
          <button
            onClick={handleInstall}
            disabled={installState !== "idle"}
            className={installState}
          >
            {installState === "idle" && "Install"}
            {installState === "installing" && "Installing…"}
            {installState === "installed" && "Installed ✓"}
          </button>
        )}

        {showIOSBanner && (
          <p className="ios-hint">
            Tap <b>Share</b> → <b>Add to Home Screen</b>
          </p>
        )}

        <button className="cancel" onClick={close}>
          Not now
        </button>
      </div>
    </div>
  );
}
